import React from "react";
import Game from "./Game";
import { useTranslation } from "../hooks/hooks";
import { gamesUserFavoritesAtom } from "../state/games";
import { useAtom } from "jotai";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { routes } from "../router/Routes";
import Icon from "./Icon";
import { ArrowRightIcon } from "./Icons";

const FavoriteGamesLobby = () => {
    const { _e } = useTranslation();
    const [games] = useAtom(gamesUserFavoritesAtom);
    const navigate = useNavigate();
    return (
        <>
            <div className="games-section games-favorites">
                <div className="title-wrap">
                    <h2 className="title-1"> {_e("MY FAVOURITES")}</h2>
                    <div className="text-right">
                        <Button
                            variant="text"
                            onClick={() => {
                                navigate(routes.pages.favorites);
                            }}
                            className="btn-primary"
                        >
                            {_e("VIEW ALL")}
                            <Icon icon={ArrowRightIcon} />
                        </Button>
                    </div>
                </div>
                <div className="games-inner">
                    <div className="games">
                        {games !== null &&
                            games.games.slice(0, 6).map(game => {
                                return <Game game={game} key={game.id} />;
                            })}
                    </div>
                </div>
            </div>
        </>
    );
};

export default FavoriteGamesLobby;
